export default "__VITE_ASSET__Dkzh8k3n__"